"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const playlistImages_1 = require("../../components/playlists/playlistImages");
const createElement_1 = require("../../utils/dom/createElement");
const getTracksCountString_1 = require("../../utils/tracks/getTracksCountString");
const spinner_png_1 = __importDefault(require("../../resources/img/spinner.png"));
class DeletePlaylistModalService {
    constructor(modalService, playlistsModel) {
        this.modalService = modalService;
        this.playlistsModel = playlistsModel;
    }
    open(onDeleteCallback) {
        const modalDiv = this.createModalElement();
        this.addPlaylistButtons(modalDiv, onDeleteCallback);
        this.addCancelButton(modalDiv);
        this.modalService.open(modalDiv);
    }
    close() {
        this.modalService.close();
    }
    createModalElement() {
        return (0, createElement_1.createElement)(`
      <div class="playlists-modal">
          <div class="playlists-modal__title">
              Удалить плейлист
          </div>
          <div class="playlists-modal__playlist_content">
          </div>
          <div class="playlists-modal__footer">
              <div class="playlists-modal__close-btn">
                  Отменить
              </div>
          </div>
          <div class="loading modal-loading loading_hidden" id="modal-loading">
            <img class="loading__spinner" src="${spinner_png_1.default}" alt="Идёт загрузка">
          </div>
      </div>
    `);
    }
    addPlaylistButtons(modalDiv, onDeleteCallback) {
        const buttonsContainer = modalDiv.querySelector('.playlists-modal__playlist_content');
        for (const playlist of this.playlistsModel.playlists) {
            const playlistButton = this.addPlaylistButton(playlist);
            playlistButton.addEventListener('click', async () => {
                const loadingElement = document.getElementById('modal-loading');
                if (!loadingElement) {
                    throw new Error('Could not find element with id: "modal-loading"');
                }
                loadingElement.classList.remove('loading_hidden');
                await onDeleteCallback(playlist.id);
                loadingElement.classList.add('loading_hidden');
            });
            buttonsContainer === null || buttonsContainer === void 0 ? void 0 : buttonsContainer.append(playlistButton);
        }
    }
    addPlaylistButton(playlist) {
        const imageId = playlist.id % playlistImages_1.PLAYLIST_IMAGES.small.length;
        const imageSrc = playlistImages_1.PLAYLIST_IMAGES.small[imageId];
        const countString = (0, getTracksCountString_1.getTracksCountString)(playlist.songs.length);
        if (!imageSrc) {
            throw new Error(`Image with id: ${imageId} not found`);
        }
        return (0, createElement_1.createElement)(`
      <div class="playlists-modal__playlist">
          <img src="${imageSrc}" alt="" class="playlists-modal__playlist__image"/>
          <div class="playlists-modal__playlist__title">
            ${playlist.name}
          </div>
          <div class="playlists-modal__playlist__info">
            ${countString}
          </div>
      </div>
    `);
    }
    addCancelButton(modalDiv) {
        const cancelButton = modalDiv.querySelector('.playlists-modal__close-btn');
        if (!cancelButton) {
            throw new Error('playlists-modal__close-btn is not found');
        }
        cancelButton.addEventListener('click', () => this.close());
    }
}
exports.default = DeletePlaylistModalService;
